import React from "react"
import { Dialog, FlatButton } from "material-ui"
import { EScheduleConstraintSeverity, IScheduleConstraint } from "../../../models"
import strings from "../../../localization/strings"
import ScheduleConstraintsTable from "./ScheduleConstraintsTable"
interface IProps {
	constraints: IScheduleConstraint[]
	handleClose(): void
	handleProceed?(): void
}

const ScheduleConstraintsAlertDialog: React.SFC<IProps> = (props: IProps) => {
	return (
		<Dialog
			open
			autoScrollBodyContent
			title={props.handleProceed && !props.constraints.find(i => i.Severity === EScheduleConstraintSeverity.Error) ?
				strings.Schedule_document_has_warning_validations :
				strings.Schedule_document_has_not_passed_validations
			}
			actions={[
				<FlatButton
					data-intercom-target={"ScheduleConstraintsAlertDialog-CloseBtn"}
					label={strings.Close}
					primary={props.handleProceed ? false : true}
					onClick={props.handleClose}
				/>,
				props.handleProceed &&
				<FlatButton
					data-intercom-target={"ScheduleConstraintsAlertDialog-ProceedBtn"}
					label={strings.Proceed}
					primary={true}
					keyboardFocused={true}
					onClick={() => {
						props.handleClose()
						props.handleProceed()
					}}
				/>,
			]}
		>
			<div style={{ paddingRight: 20, paddingLeft: 20 }}>
				<ScheduleConstraintsTable
					constraints={props.constraints}
				/>
			</div>
		</Dialog>
	)
}

export default ScheduleConstraintsAlertDialog